module.exports = __webpack_public_path__ + "static/media/HighAngelOfAether03.8af9589f.jpg";